import React, { Component } from "react";
import classes from "./SideDrawer.module.css";

import { Link } from "react-router-dom";
import { connect } from "react-redux";

import BackButton from "../../components/Images/BackButton/BackButton";
import SDButton from "../../components/SDButton/SDButton";

import * as bodyDrawerFunctions from "../../store/BodyDrawerReducer/bodyDrawerFunctions";

class SideDrawer extends Component {
  state = {};

  render() {
    const Buttons = this.props.links.map((element) => {
      return (
        <SDButton
          onClick={() => this.props.onClickTab(element.name)}
          key={element.name}
          imageURI={element.image}
        >
          {element.name}
        </SDButton>
      );
    });

    return (
      <div className={classes.SideDrawer}>
        <Link to="/" onClick={this.props.onBackClicked}>
          <BackButton />
        </Link>
        {Buttons}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    links: state.actRed.linkName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickTab: (tabName) => dispatch(bodyDrawerFunctions.clickTab(tabName)),
    onBackClicked: () => dispatch(bodyDrawerFunctions.backClicked()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer);
